import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { RequestStatus } from '@beef/smart-kit';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
export var _RenderRequestStatus = function _RenderRequestStatus(_ref) {
  var texts = _ref.texts,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(RequestStatus, {
    button: texts.button,
    description: texts.description,
    img: texts.img,
    onConfirm: onClose,
    title: texts.title,
    withModal: true,
    "data-t-id": "components-RenderRequestStatus"
  });
};
_RenderRequestStatus.propTypes = process.env.NODE_ENV !== "production" ? {
  texts: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    img: PropTypes.shape({
      src: PropTypes.string
    }),
    button: PropTypes.shape({
      title: PropTypes.string
    })
  }),
  onClose: PropTypes.func
} : {};
var mapStateToProps = function mapStateToProps(_state, _ref2) {
  var texts = _ref2.texts;
  return {
    shouldRender: !isEmpty(texts)
  };
};
export var RenderRequestStatus = compose(connect(mapStateToProps), withRenderFlag)(_RenderRequestStatus);